export const downloadWarningTreshold = 0.9
